import { array, dateTime, defineAction, number, object, string } from '~/prix'
import action from './legalEntityAttendanceList.action.json'

const legalEntityAttendanceListDefinition = defineAction({
  ...action,
  input: object({
    legalEntityId: string().label('ID da empresa'),
    dataSourceId: number().isOptional().label('ID da fonte de dados'),
  }),
  output: object({
    items: array(
      object({
        id: string(),
        dataSourceId: number(),
        dataSourceName: string(),
        instrument: string(),
        startDate: dateTime(),
        endDate: dateTime().isOptional(),
        agentName: string().isOptional(),
        attendanceQuantity: number().isOptional(),
        latitude: number().isOptional(),
        longitude: number().isOptional(),
        accuracy: number().isOptional(),
        justify: string().isOptional(),
        imageUrl: string().isOptional(),
        imageUrls: array(string()).isOptional(),
      }),
    ),
  }),
})

export default legalEntityAttendanceListDefinition
